import React from "react";

function DropdownOptionsHeader({ heading, className }: { heading: string | JSX.Element, className: string }) {
    return <div className={className}>
        {heading || "Choose"}
    </div>;
}

export default DropdownOptionsHeader;
